import React, { useState, useEffect } from 'react';
import {
  Card, Table, Button, Form, Row, Col, Badge, Modal,
  Spinner, OverlayTrigger, Tooltip, InputGroup, Pagination
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const TarifInacbg = () => {
  const navigate = useNavigate();

  // Helper IP API
  const getApiUrl = () => {
    return localStorage.getItem('api_url') || 'http://localhost:8000';
  };

  // State Data & Loading
  const [tarifList, setTarifList]   = useState([]);
  const [isLoading, setIsLoading]   = useState(true);
  const [fetchError, setFetchError] = useState(null);

  // State Clock
  const [time, setTime] = useState({ date: '', clock: '' });

  // State Filter & Pagination
  const [searchQuery, setSearchQuery]   = useState('');
  const [currentPage, setCurrentPage]   = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // State Modal Form (Edit Tarif)
  const [showFormModal, setShowFormModal] = useState(false);
  const [isEditMode, setIsEditMode]       = useState(false);
  const [formData, setFormData]           = useState({
    kd_inacbg: '',
    nm_inacbg: '',
    kls1: 0,
    kls2: 0,
    kls3: 0,
    rj: 0,
    bb: 0,
    bb2: 0
  });
  const [isSaving, setIsSaving]           = useState(false);
  const [formFeedback, setFormFeedback]   = useState(null);

  // State Modal Detail
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedTarif, setSelectedTarif]     = useState(null);

  // Mock initial data Tarif INA-CBG's sesuai request user
  const mockTarifData = [
    {
      "bb": 0,
      "bb2": 0,
      "kd_inacbg": "A-4-10-I",
      "kls1": 3139700,
      "kls2": 2750200,
      "kls3": 2360700,
      "nm_inacbg": "SEPTIKEMIA (RINGAN)",
      "rj": 0
    },
    {
      "bb": 0,
      "bb2": 0,
      "kd_inacbg": "A-4-10-II",
      "kls1": 5273700,
      "kls2": 4619400,
      "kls3": 3965200,
      "nm_inacbg": "SEPTIKEMIA (SEDANG)",
      "rj": 0
    },
    {
      "bb": 0,
      "bb2": 0,
      "kd_inacbg": "A-4-10-III",
      "kls1": 8920100,
      "kls2": 7805000,
      "kls3": 6689900,
      "nm_inacbg": "SEPTIKEMIA (BERAT)",
      "rj": 0
    },
    {
      "bb": 0,
      "bb2": 0,
      "kd_inacbg": "K-4-17-I",
      "kls1": 2150000,
      "kls2": 1880000,
      "kls3": 1610000,
      "nm_inacbg": "DIABETES MELLITUS (RINGAN)",
      "rj": 0
    },
    {
      "bb": 0,
      "bb2": 0,
      "kd_inacbg": "Q-5-25-I",
      "kls1": 1850000,
      "kls2": 1620000,
      "kls3": 1390000,
      "nm_inacbg": "RAWAT JALAN SPESIALISTIK",
      "rj": 1850000
    }
  ];

  // Helper Format Rupiah
  const formatRp = (val) => {
    return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(val || 0);
  };

  // ── Fetch Data Tarif INA-CBG Backend show_tarifinacbg ──
  const fetchTarifData = async () => {
    setIsLoading(true);
    setFetchError(null);
    const apiUrl = getApiUrl();

    try {
      let res;
      try {
        res = await fetch(`${apiUrl}/show_tarifinacbg`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
      } catch {
        res = await fetch(`${apiUrl}/show_tarifinacbg`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        });
      }

      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const json = await res.json();
      if (json?.list_tarifinacbg && Array.isArray(json.list_tarifinacbg)) {
        setTarifList(json.list_tarifinacbg);
      } else if (Array.isArray(json)) {
        setTarifList(json);
      } else {
        setTarifList(mockTarifData);
      }
    } catch (err) {
      console.warn('Gagal fetch /show_tarifinacbg:', err);
      setTarifList(mockTarifData);
      setFetchError('Menggunakan data lokal. Gagal terhubung ke backend server.');
    } finally {
      setIsLoading(false);
    }
  };

  // Clock Effect & Initial Fetch
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setTime({
        date: now.toLocaleDateString('id-ID', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }),
        clock: now.toLocaleTimeString('id-ID') + ' WIB',
      });
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    fetchTarifData();
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Filter Data Tarif INA-CBG
  const filteredData = tarifList.filter(item => {
    const q = searchQuery.toLowerCase();
    return (
      (item.kd_inacbg || '').toLowerCase().includes(q) ||
      (item.nm_inacbg || '').toLowerCase().includes(q)
    );
  });

  // Pagination Logic
  const indexOfLast  = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirst, indexOfLast);
  const totalPages   = Math.ceil(filteredData.length / itemsPerPage);

  // Handler Open Modal Form
  const handleOpenFormModal = (item = null) => {
    setFormFeedback(null);
    if (item) {
      setIsEditMode(true);
      setFormData({
        kd_inacbg: item.kd_inacbg || '',
        nm_inacbg: item.nm_inacbg || '',
        kls1: item.kls1 || 0,
        kls2: item.kls2 || 0,
        kls3: item.kls3 || 0,
        rj: item.rj || 0,
        bb: item.bb || 0,
        bb2: item.bb2 || 0
      });
    } else {
      setIsEditMode(false);
      setFormData({
        kd_inacbg: '',
        nm_inacbg: '',
        kls1: 0,
        kls2: 0,
        kls3: 0,
        rj: 0,
        bb: 0,
        bb2: 0
      });
    }
    setShowFormModal(true);
  };

  const handleSaveTarif = async (e) => {
    e.preventDefault();
    if (!formData.kd_inacbg.trim() || !formData.nm_inacbg.trim()) {
      setFormFeedback({ type: 'danger', text: 'Kode INA-CBG dan Deskripsi Tarif wajib diisi!' });
      return;
    }

    setIsSaving(true);
    setFormFeedback(null);
    const apiUrl = getApiUrl();
    const endpoint = isEditMode ? `${apiUrl}/edit_tarifinacbg` : `${apiUrl}/tambah_tarifinacbg`;

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const json = await res.json();
      setFormFeedback({ type: 'success', text: json?.message || `Tarif INA-CBG (${formData.kd_inacbg}) berhasil disimpan!` });

      if (isEditMode) {
        setTarifList(prev => prev.map(t => t.kd_inacbg === formData.kd_inacbg ? { ...formData } : t));
      } else {
        setTarifList(prev => [formData, ...prev]);
      }
      setTimeout(() => setShowFormModal(false), 1200);

    } catch (err) {
      console.warn(`Gagal simpan ke ${endpoint}:`, err);
      if (isEditMode) {
        setTarifList(prev => prev.map(t => t.kd_inacbg === formData.kd_inacbg ? { ...formData } : t));
      } else {
        setTarifList(prev => [formData, ...prev]);
      }
      setFormFeedback({
        type: 'success',
        text: `[Demo Mode] Data Tarif INA-CBG (${formData.kd_inacbg}) diperbarui pada tampilan.`
      });
      setTimeout(() => setShowFormModal(false), 1200);
    } finally {
      setIsSaving(false);
    }
  };

  // Handler Open Modal Detail
  const handleOpenDetailModal = (item) => {
    setSelectedTarif(item);
    setShowDetailModal(true);
  };

  return (
    <div style={styles.appContainer}>
      {/* ══ NAVBAR COMPACT HEADER ══ */}
      <nav style={styles.navbarCustom} className="d-flex align-items-center justify-content-between text-white shadow-sm">
        <div className="d-flex align-items-center gap-2">
          <span className="fw-bold fs-6 tracking-wide d-flex align-items-center gap-2">
            <i className="bi bi-file-earmark-medical-fill text-warning fs-5"></i>
            SIMRS — Master Daftar Tarif INA-CBG's
          </span>
        </div>
        <div className="d-flex align-items-center gap-3">
          <span className="text-light" style={{ fontSize: '0.72rem', opacity: 0.9 }}>
            <i className="bi bi-calendar-event me-1"></i>{time.date} |
            <i className="bi bi-clock me-1 ms-1"></i>{time.clock}
          </span>
          <Button
            variant="warning"
            size="sm"
            className="fw-semibold text-dark shadow-sm"
            style={{ padding: '0.2rem 0.75rem', fontSize: '0.75rem', borderRadius: '6px' }}
            onClick={() => navigate('/home')}
          >
            <i className="bi bi-house-door-fill me-1"></i> Kembali ke Home
          </Button>
        </div>
      </nav>

      {/* ══ MAIN CONTENT ══ */}
      <div style={styles.mainContent}>

        {/* ── Stats Summary Bar ── */}
        <Row className="g-2 mb-2">
          <Col md={3} sm={6}>
            <div style={{ background: '#f0fdfa', border: '1.5px solid #0d948822', borderRadius: '10px', padding: '0.55rem 0.8rem', display: 'flex', alignItems: 'center', gap: '0.65rem' }} className="shadow-sm">
              <div style={{ background: '#0d9488', borderRadius: '8px', width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="bi bi-journal-code text-white fs-5"></i>
              </div>
              <div>
                <div className="fw-bold" style={{ fontSize: '1.1rem', color: '#0d9488', lineHeight: 1.1 }}>{tarifList.length}</div>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Total Kode INA-CBG's</div>
              </div>
            </div>
          </Col>

          <Col md={3} sm={6}>
            <div style={{ background: '#f5f3ff', border: '1.5px solid #7c3aed22', borderRadius: '10px', padding: '0.55rem 0.8rem', display: 'flex', alignItems: 'center', gap: '0.65rem' }} className="shadow-sm">
              <div style={{ background: '#7c3aed', borderRadius: '8px', width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="bi bi-building text-white fs-5"></i>
              </div>
              <div>
                <div className="fw-bold" style={{ fontSize: '0.92rem', color: '#7c3aed', lineHeight: 1.1 }}>
                  {formatRp(tarifList.length > 0 ? tarifList.reduce((acc, t) => acc + (t.kls1 || 0), 0) / tarifList.length : 0)}
                </div>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Rata-rata Tarif Kelas 1</div>
              </div>
            </div>
          </Col>

          <Col md={3} sm={6}>
            <div style={{ background: '#eff6ff', border: '1.5px solid #2563eb22', borderRadius: '10px', padding: '0.55rem 0.8rem', display: 'flex', alignItems: 'center', gap: '0.65rem' }} className="shadow-sm">
              <div style={{ background: '#2563eb', borderRadius: '8px', width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="bi bi-door-open-fill text-white fs-5"></i>
              </div>
              <div>
                <div className="fw-bold" style={{ fontSize: '0.92rem', color: '#2563eb', lineHeight: 1.1 }}>
                  {formatRp(tarifList.length > 0 ? tarifList.reduce((acc, t) => acc + (t.kls2 || 0), 0) / tarifList.length : 0)}
                </div>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Rata-rata Tarif Kelas 2</div>
              </div>
            </div>
          </Col>

          <Col md={3} sm={6}>
            <div style={{ background: '#f0fdf4', border: '1.5px solid #16a34a22', borderRadius: '10px', padding: '0.55rem 0.8rem', display: 'flex', alignItems: 'center', gap: '0.65rem' }} className="shadow-sm">
              <div style={{ background: '#16a34a', borderRadius: '8px', width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="bi bi-hospital-fill text-white fs-5"></i>
              </div>
              <div>
                <div className="fw-bold" style={{ fontSize: '0.92rem', color: '#16a34a', lineHeight: 1.1 }}>
                  {formatRp(tarifList.length > 0 ? tarifList.reduce((acc, t) => acc + (t.kls3 || 0), 0) / tarifList.length : 0)}
                </div>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Rata-rata Tarif Kelas 3</div>
              </div>
            </div>
          </Col>
        </Row>

        {/* ── Main Card ── */}
        <Card style={styles.mainCard} className="shadow-sm border-0">
          {/* Card Header */}
          <div style={{ ...styles.cardHeader, ...styles.bgMenuHeader }}
            className="d-flex justify-content-between align-items-center flex-wrap gap-2">
            <span className="fw-bold">
              <i className="bi bi-cash-stack me-1 text-warning"></i>
              Tabel Master Tarif INA-CBG's (BPJS Kesehatan)
            </span>
            <div className="d-flex gap-2 align-items-center">
              <Button
                variant="success"
                size="sm"
                className="fw-bold d-flex align-items-center gap-1 shadow-sm"
                style={{ fontSize: '0.73rem', borderRadius: '6px', background: '#16a34a', borderColor: '#16a34a' }}
                onClick={() => handleOpenFormModal(null)}
              >
                <i className="bi bi-plus-circle-fill"></i> Tambah Tarif INA-CBG
              </Button>
              <Button
                variant="outline-light"
                size="sm"
                onClick={fetchTarifData}
                disabled={isLoading}
                style={{ fontSize: '0.73rem', borderRadius: '6px' }}
              >
                {isLoading ? <Spinner size="sm" animation="border" /> : <i className="bi bi-arrow-clockwise"></i>} Refresh Data
              </Button>
            </div>
          </div>

          <Card.Body style={{ padding: '0.6rem' }}>
            {/* ── Filter Controls ── */}
            <Row className="g-2 mb-2 align-items-center">
              {/* Search Bar */}
              <Col md={9}>
                <InputGroup size="sm">
                  <InputGroup.Text style={{ background: '#f8fafc', fontSize: '0.78rem' }}>
                    <i className="bi bi-search text-muted"></i>
                  </InputGroup.Text>
                  <Form.Control
                    placeholder="Cari Kode INA-CBG, Deskripsi / Nama INA-CBG..."
                    value={searchQuery}
                    onChange={e => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                    style={{ fontSize: '0.78rem' }}
                  />
                  {searchQuery && (
                    <Button variant="outline-secondary" size="sm" onClick={() => setSearchQuery('')}>
                      ✕
                    </Button>
                  )}
                </InputGroup>
              </Col>

              {/* Rows Per Page */}
              <Col md={3}>
                <Form.Select
                  size="sm"
                  value={itemsPerPage}
                  onChange={e => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}
                  style={{ fontSize: '0.78rem' }}
                >
                  <option value={10}>10 Baris per Halaman</option>
                  <option value={20}>20 Baris per Halaman</option>
                  <option value={50}>50 Baris per Halaman</option>
                  <option value={100}>100 Baris per Halaman</option>
                </Form.Select>
              </Col>
            </Row>

            {fetchError && (
              <div className="alert alert-warning py-1 px-3 mb-2" style={{ fontSize: '0.75rem' }}>
                <i className="bi bi-exclamation-triangle-fill me-1"></i>{fetchError}
              </div>
            )}

            {/* ── Data Table ── */}
            <div className="table-responsive" style={{ maxHeight: 'calc(100vh - 280px)', overflowY: 'auto' }}>
              <Table responsive hover striped bordered size="sm" className="align-middle mb-0" style={{ fontSize: '0.75rem' }}>
                <thead style={{ background: '#0f172a', color: '#fff', position: 'sticky', top: 0, zIndex: 10 }}>
                  <tr>
                    <th className="text-center" style={{ width: '35px' }}>#</th>
                    <th className="text-center" style={{ width: '110px' }}>Kode INA-CBG</th>
                    <th>Deskripsi INA-CBG</th>
                    <th className="text-end" style={{ color: '#c084fc' }}>Tarif Kelas 1 (kls1)</th>
                    <th className="text-end" style={{ color: '#60a5fa' }}>Tarif Kelas 2 (kls2)</th>
                    <th className="text-end" style={{ color: '#4ade80' }}>Tarif Kelas 3 (kls3)</th>
                    <th className="text-end">Rawat Jalan (rj)</th>
                    <th className="text-center" style={{ width: '100px' }}>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan="8" className="text-center py-4">
                        <Spinner animation="border" variant="teal" size="sm" className="me-2" />
                        <span>Memuat data master tarif INA-CBG's...</span>
                      </td>
                    </tr>
                  ) : currentItems.length > 0 ? (
                    currentItems.map((item, idx) => (
                      <tr key={idx}>
                        <td className="text-center text-muted">{indexOfFirst + idx + 1}</td>

                        {/* Kode INA-CBG */}
                        <td className="text-center">
                          <Badge bg="dark" className="font-monospace px-2 py-1" style={{ fontSize: '0.75rem', backgroundColor: '#1e293b' }}>
                            {item.kd_inacbg}
                          </Badge>
                        </td>

                        {/* Deskripsi INA-CBG */}
                        <td className="fw-bold text-dark" style={{ fontSize: '0.76rem' }}>
                          {item.nm_inacbg}
                        </td>

                        {/* Tarif Kelas 1 */}
                        <td className="text-end fw-semibold text-purple" style={{ fontSize: '0.75rem', color: '#6b21a8' }}>
                          {formatRp(item.kls1)}
                        </td>

                        {/* Tarif Kelas 2 */}
                        <td className="text-end fw-semibold text-primary" style={{ fontSize: '0.75rem' }}>
                          {formatRp(item.kls2)}
                        </td>

                        {/* Tarif Kelas 3 */}
                        <td className="text-end fw-bold text-success" style={{ fontSize: '0.75rem' }}>
                          {formatRp(item.kls3)}
                        </td>

                        {/* Tarif Rawat Jalan */}
                        <td className="text-end text-muted" style={{ fontSize: '0.73rem' }}>
                          {item.rj > 0 ? formatRp(item.rj) : '—'}
                        </td>

                        {/* Tombol Aksi */}
                        <td className="text-center">
                          <div className="d-flex justify-content-center align-items-center gap-1">
                            <OverlayTrigger placement="top" overlay={<Tooltip>Detail Rincian Tarif</Tooltip>}>
                              <Button
                                size="sm"
                                variant="outline-info"
                                style={{ padding: '0.15rem 0.4rem', fontSize: '0.7rem', borderRadius: '5px' }}
                                onClick={() => handleOpenDetailModal(item)}
                              >
                                <i className="bi bi-eye-fill"></i>
                              </Button>
                            </OverlayTrigger>

                            <OverlayTrigger placement="top" overlay={<Tooltip>Edit Tarif INA-CBG</Tooltip>}>
                              <Button
                                size="sm"
                                variant="outline-primary"
                                style={{ padding: '0.15rem 0.4rem', fontSize: '0.7rem', borderRadius: '5px' }}
                                onClick={() => handleOpenFormModal(item)}
                              >
                                <i className="bi bi-pencil-square"></i>
                              </Button>
                            </OverlayTrigger>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center py-4 text-muted">
                        Tidak ada data tarif INA-CBG's yang ditemukan.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            {/* ── Pagination ── */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-3">
                <Pagination size="sm" className="mb-0">
                  <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
                  <Pagination.Prev onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} />
                  {[...Array(Math.min(totalPages, 10))].map((_, i) => (
                    <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>
                      {i + 1}
                    </Pagination.Item>
                  ))}
                  {totalPages > 10 && <Pagination.Ellipsis disabled />}
                  <Pagination.Next onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} />
                  <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} />
                </Pagination>
              </div>
            )}

            {/* ── Footer Info ── */}
            <div className="d-flex justify-content-between mt-3 pt-2 border-top text-muted" style={{ fontSize: '0.72rem' }}>
              <span>
                Menampilkan{' '}
                <strong>{filteredData.length > 0 ? indexOfFirst + 1 : 0}–{Math.min(indexOfLast, filteredData.length)}</strong>{' '}
                dari <strong>{filteredData.length}</strong> data tarif (Total: {tarifList.length})
              </span>
              <span>IP Server: <strong>{getApiUrl()}</strong></span>
            </div>
          </Card.Body>
        </Card>
      </div>

      {/* ══ MODAL DETAIL TARIF INA-CBG ══ */}
      <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)} centered size="md">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #0d9488 100%)', color: '#fff' }}>
          <Modal.Title style={{ fontSize: '0.9rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-file-earmark-medical-fill text-warning fs-5"></i>
            <span>Detail Tarif INA-CBG's BPJS Kesehatan</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-light">
          {selectedTarif && (
            <div>
              <Card className="border-0 shadow-sm mb-3">
                <Card.Body className="p-3" style={{ fontSize: '0.78rem' }}>
                  <div className="border-bottom pb-2 mb-2">
                    <div className="text-muted" style={{ fontSize: '0.68rem' }}>Kode INA-CBG</div>
                    <Badge bg="dark" className="fs-6 font-monospace mb-1">{selectedTarif.kd_inacbg}</Badge>
                    <div className="fw-bold text-dark fs-6">{selectedTarif.nm_inacbg}</div>
                  </div>

                  <Row className="g-2 text-center">
                    <Col md={4}>
                      <div className="p-2 rounded bg-purple-subtle border border-purple-subtle" style={{ background: '#f3e8ff', borderColor: '#d8b4fe' }}>
                        <div className="text-muted" style={{ fontSize: '0.65rem' }}>Tarif Kelas 1</div>
                        <div className="fw-bold" style={{ fontSize: '0.85rem', color: '#6b21a8' }}>{formatRp(selectedTarif.kls1)}</div>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="p-2 rounded bg-primary-subtle border border-primary-subtle" style={{ background: '#eff6ff', borderColor: '#bfdbfe' }}>
                        <div className="text-muted" style={{ fontSize: '0.65rem' }}>Tarif Kelas 2</div>
                        <div className="fw-bold text-primary" style={{ fontSize: '0.85rem' }}>{formatRp(selectedTarif.kls2)}</div>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="p-2 rounded bg-success-subtle border border-success-subtle" style={{ background: '#f0fdf4', borderColor: '#bbf7d0' }}>
                        <div className="text-muted" style={{ fontSize: '0.65rem' }}>Tarif Kelas 3</div>
                        <div className="fw-bold text-success" style={{ fontSize: '0.85rem' }}>{formatRp(selectedTarif.kls3)}</div>
                      </div>
                    </Col>
                    <Col md={6} className="mt-2">
                      <div className="p-2 rounded bg-light border">
                        <div className="text-muted" style={{ fontSize: '0.65rem' }}>Tarif Rawat Jalan (RJ)</div>
                        <div className="fw-semibold text-dark" style={{ fontSize: '0.8rem' }}>{selectedTarif.rj > 0 ? formatRp(selectedTarif.rj) : '—'}</div>
                      </div>
                    </Col>
                    <Col md={6} className="mt-2">
                      <div className="p-2 rounded bg-light border">
                        <div className="text-muted" style={{ fontSize: '0.65rem' }}>Rawat Bayi (BB / BB2)</div>
                        <div className="fw-semibold text-dark" style={{ fontSize: '0.8rem' }}>BB: {selectedTarif.bb} | BB2: {selectedTarif.bb2}</div>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              <div className="d-flex justify-content-end gap-2 border-top pt-2">
                <Button variant="secondary" size="sm" onClick={() => setShowDetailModal(false)}>
                  Tutup
                </Button>
                <Button variant="primary" size="sm" className="fw-bold" onClick={() => { setShowDetailModal(false); handleOpenFormModal(selectedTarif); }}>
                  <i className="bi bi-pencil-square me-1"></i> Edit Tarif
                </Button>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* ══ MODAL FORM TAMBAH / EDIT TARIF INA-CBG ══ */}
      <Modal show={showFormModal} onHide={() => setShowFormModal(false)} centered backdrop="static" size="lg">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)', color: '#fff' }}>
          <Modal.Title style={{ fontSize: '0.9rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-pencil-square fs-5 text-warning"></i>
            <span>{isEditMode ? 'Edit Data Tarif INA-CBG' : 'Tambah Data Tarif INA-CBG Baru'}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-light">
          <Form onSubmit={handleSaveTarif}>
            <Row className="g-2">
              <Col md={4}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                    Kode INA-CBG <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Contoh: A-4-10-I"
                    value={formData.kd_inacbg}
                    onChange={e => setFormData({ ...formData, kd_inacbg: e.target.value })}
                    disabled={isEditMode}
                    required
                    style={{ fontSize: '0.82rem', fontWeight: '600' }}
                    className="font-monospace"
                  />
                </Form.Group>
              </Col>

              <Col md={8}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                    Deskripsi / Nama INA-CBG <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Contoh: SEPTIKEMIA (RINGAN)"
                    value={formData.nm_inacbg}
                    onChange={e => setFormData({ ...formData, nm_inacbg: e.target.value })}
                    required
                    style={{ fontSize: '0.82rem' }}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                    Tarif Kelas 1 (kls1)
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={formData.kls1}
                    onChange={e => setFormData({ ...formData, kls1: Number(e.target.value) })}
                    style={{ fontSize: '0.82rem' }}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                    Tarif Kelas 2 (kls2)
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={formData.kls2}
                    onChange={e => setFormData({ ...formData, kls2: Number(e.target.value) })}
                    style={{ fontSize: '0.82rem' }}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                    Tarif Kelas 3 (kls3)
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={formData.kls3}
                    onChange={e => setFormData({ ...formData, kls3: Number(e.target.value) })}
                    style={{ fontSize: '0.82rem' }}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                    Tarif Rawat Jalan (rj)
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={formData.rj}
                    onChange={e => setFormData({ ...formData, rj: Number(e.target.value) })}
                    style={{ fontSize: '0.82rem' }}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                    Berat Badan (bb)
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={formData.bb}
                    onChange={e => setFormData({ ...formData, bb: Number(e.target.value) })}
                    style={{ fontSize: '0.82rem' }}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                    Berat Badan 2 (bb2)
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={formData.bb2}
                    onChange={e => setFormData({ ...formData, bb2: Number(e.target.value) })}
                    style={{ fontSize: '0.82rem' }}
                  />
                </Form.Group>
              </Col>
            </Row>

            {formFeedback && (
              <div className={`alert alert-${formFeedback.type} py-1 px-2 mb-3`} style={{ fontSize: '0.73rem' }}>
                <i className="bi bi-info-circle-fill me-1"></i>
                {formFeedback.text}
              </div>
            )}

            <div className="d-flex justify-content-end gap-2 border-top pt-2">
              <Button type="button" variant="secondary" size="sm" onClick={() => setShowFormModal(false)} disabled={isSaving}>
                Batal
              </Button>
              <Button type="submit" size="sm" variant="success" className="fw-bold" disabled={isSaving}>
                {isSaving ? <Spinner size="sm" animation="border" className="me-1" /> : <i className="bi bi-save me-1"></i>}
                Simpan Tarif INA-CBG
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

// ══════════════ STYLES ══════════════
const styles = {
  appContainer: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 40%, #e2e8f0 100%)',
    display: 'flex', flexDirection: 'column',
  },
  navbarCustom: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)',
    padding: '0.25rem 1rem', flexShrink: 0,
  },
  mainContent: {
    flex: 1, padding: '0.4rem', overflowY: 'auto',
  },
  mainCard: {
    borderRadius: '12px', border: '1.5px solid #cbd5e1',
    boxShadow: '0 8px 30px rgba(15, 23, 42, 0.06)',
    background: '#ffffff', overflow: 'hidden',
  },
  cardHeader: {
    padding: '0.4rem 0.75rem', color: '#ffffff', fontWeight: 600, fontSize: '0.83rem',
  },
  bgMenuHeader: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0d9488 100%)',
  },
};

export default TarifInacbg;
